module.exports = __webpack_public_path__ + "static/img/gift_es.49487e6f.png";